module.exports = __webpack_public_path__ + "img/layers.b5331e87.svg";